import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './ChangePasswordModal.module.css';
import api from '../../services/api';

const ChangePasswordModal = ({ open, onClose }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [serverMessage, setServerMessage] = useState('');

  if (!open) {
    return null;
  }

  const resetState = () => {
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
    setLoading(false);
    setErrors({});
    setServerMessage('');
  };

  const handleClose = () => {
    resetState();
    onClose();
  };

  const validate = () => {
    const nextErrors = {};

    if (!currentPassword) {
      nextErrors.currentPassword = '请输入当前密码';
    }

    if (!newPassword) {
      nextErrors.newPassword = '请输入新密码';
    } else if (newPassword.length < 6 || newPassword.length > 64) {
      nextErrors.newPassword = '新密码长度需在 6-64 个字符之间';
    }

    if (!confirmPassword) {
      nextErrors.confirmPassword = '请再次输入新密码';
    } else if (newPassword && confirmPassword !== newPassword) {
      nextErrors.confirmPassword = '两次输入的新密码不一致';
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setServerMessage('');

    if (!validate()) {
      return;
    }

    try {
      setLoading(true);
      await api.post('/auth/change-password', {
        current_password: currentPassword,
        new_password: newPassword,
      });
      setServerMessage('密码修改成功');
      resetState();
      onClose();
      alert('密码修改成功，请重新登录');
      localStorage.removeItem('token');
      window.location.href = '/login';
    } catch (error) {
      const message = error?.response?.data?.detail || '密码修改失败，请稍后重试';
      setServerMessage(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.backdrop} role="presentation" onClick={handleClose}>
      <div
        className={styles.modal}
        role="dialog"
        aria-modal="true"
        aria-labelledby="change-password-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className={styles.header}>
          <h2 id="change-password-title" className={styles.title}>更改密码</h2>
          <button type="button" className={styles.closeBtn} onClick={handleClose} aria-label="关闭">
            ×
          </button>
        </header>

        <form className={styles.form} onSubmit={handleSubmit}>
          <label className={styles.label} htmlFor="currentPassword">
            当前密码
          </label>
          <input
            id="currentPassword"
            type="password"
            className={`${styles.input} ${errors.currentPassword ? styles.inputError : ''}`}
            value={currentPassword}
            onChange={(event) => setCurrentPassword(event.target.value)}
            autoComplete="current-password"
          />
          {errors.currentPassword && <div className={styles.error}>{errors.currentPassword}</div>}

          <label className={styles.label} htmlFor="newPassword">
            新密码
          </label>
          <input
            id="newPassword"
            type="password"
            className={`${styles.input} ${errors.newPassword ? styles.inputError : ''}`}
            value={newPassword}
            onChange={(event) => setNewPassword(event.target.value)}
            autoComplete="new-password"
          />
          {errors.newPassword && <div className={styles.error}>{errors.newPassword}</div>}

          <label className={styles.label} htmlFor="confirmPassword">
            再次输入新密码
          </label>
          <input
            id="confirmPassword"
            type="password"
            className={`${styles.input} ${errors.confirmPassword ? styles.inputError : ''}`}
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value)}
            autoComplete="new-password"
          />
          {errors.confirmPassword && <div className={styles.error}>{errors.confirmPassword}</div>}

          {serverMessage && <div className={styles.serverMessage}>{serverMessage}</div>}

          <div className={styles.actions}>
            <button type="button" className={styles.cancelBtn} onClick={handleClose} disabled={loading}>
              取消
            </button>
            <button type="submit" className={styles.submitBtn} disabled={loading}>
              {loading ? '提交中…' : '确认修改'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

ChangePasswordModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ChangePasswordModal;
